/** API route map: URLS.Controller.ClientHolidaysCalender */
export const ClientHolidaysCalender = {
      Name: 'ClientHolidayCalender/',
      GetHolidaysCalenders: 'get-all',
      AddHolidaysCalender: 'add',
      UpdateHolidaysCalender: 'update',
      DeleteHolidaysCalender: 'delete',
};
